import { createSelector } from 'reselect';

// Config
import { getAppOrderCompleteSelector } from '@redux/reducers/app/appSelector';
import {
  getDeliveriesSelector,
  getUndeliverableItemsInBasketSelector,
} from '@redux/reducers/delivery/deliverySelector';

const orderItemState = createSelector(
  [getAppOrderCompleteSelector, getDeliveriesSelector, getUndeliverableItemsInBasketSelector],
  (orderComplete, deliveries, undeliverableItemsInBasket) => ({
    orderComplete,
    deliveries,
    undeliverableItemsInBasket,
  }),
);

export default orderItemState;
